import Modal from "react-modal";
import React, { useState, useRef } from "react";
import crssrImage from "../../../../../images/singleinvoice/cross-red.svg";
import { toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import { setSprintStatusView, setProjectAdded } from "../../../../../features/projects/projectSlice";

// Skeleton loader styles
const skeletonStyle = {
  backgroundColor: "#e5e7eb",
  borderRadius: "4px",
  animation: "pulse 1.5s ease-in-out infinite",
};

// Submit Button Skeleton (for Update button)
const SubmitButtonSkeleton = () => (
  <div
    style={{
      width: "100px",
      height: "38px",
      backgroundColor: "rgba(100, 121, 249, 0.6)",
      borderRadius: "4px",
      animation: "pulse 1.5s ease-in-out infinite",
    }}
  />
);

const StatusModal = (props) => {
        const dispatch = useDispatch();
        const [isSubmitLoading, setIsSubmitLoading] = useState(false);
        const sprintStatusDropdownRef = useRef(null);
        const [sprintStatusDropdownOpen, setSprintStatusDropdownOpen] = useState(false);
        const { sprintStatusView, sprintData } = useSelector((state) => state.project);
        const [sprintStatus, setSprintStatus] = useState(sprintData?.sprint_status);
        const token = useSelector((state) => state.auth.token);


        const handleSprintStatusToggleDropdown = () => {
                setSprintStatusDropdownOpen(!sprintStatusDropdownOpen);
        };

        const handleCloseStatusModal = async () => {
                setSprintStatus(null);
                setSprintStatusDropdownOpen(false);
                await dispatch(setSprintStatusView(false));
        };

        const handleSprintStatusSelectOption = (value) => {
                setSprintStatus(value);
                setSprintStatusDropdownOpen(false);
        };


        const handleStatusSubmit = async (event) => {
                event.preventDefault();
                setIsSubmitLoading(true);
                const requestData = {
                        sprint_status: sprintStatus,
                };
                try {
                        setIsSubmitLoading(true);
                        const response = await axios.put(
                                `/api/sprint-details/update/${sprintData._id}`,
                                requestData, {
                                headers: {
                                        Authorization: `Bearer ${token}`,
                                },
                        }
                        );
                        const data = response.data;
                        if (data.status === "error") {
                                toast.error("Something went wrong", {
                                        position: "bottom-right",
                                        autoClose: 2000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                });
                        } else {
                                toast.success("Sprint updated successfully", {
                                        position: "bottom-right",
                                        autoClose: 2000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                });
                                dispatch(setProjectAdded());
                                handleCloseStatusModal();
                        }
                } catch (error) {
                        console.log(error);
                        global.config.slackMessage(error.toString());
                        if (error.response?.data?.status === "deleted") {
                                localStorage.removeItem("user");
                                toast.error('This user is deleted!', {
                                        position: "bottom-right",
                                        autoClose: 1500,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                });

                                return;
                        }
                        toast.error("Something went wrong", {
                                position: "bottom-right",
                                autoClose: 2000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                        });
                        global.config.activityLog(window.location.href, 'Sprint', `Something went wrong: Sprint update`);
                } finally {
                        setIsSubmitLoading(false); // Set isLoading to false after the approval process is complete
                }
        };

        return (
                <div className="modal-invite-main-outter">
                        <Modal
                                className="client-modal sprint-modal"
                                isOpen={sprintStatusView}
                                onRequestClose={handleCloseStatusModal}
                                contentLabel="Add Team-Members to the project"
                                style={{
                                        content: {
                                                height: "41%",
                                                width: "30%",
                                                position: "fixed",
                                                top: "50%",
                                                left: "50%",
                                                parent: document.querySelector(".admin-outer.time.tracker"),
                                        },
                                }}
                        >
                                <div className="modal">
                                        <div className="modal-close-invite outter-modal-main">
                                                <a className="" onClick={handleCloseStatusModal}>
                                                        <img src={crssrImage} alt="Edit Icon" />{" "}
                                                </a>
                                        </div>
                                        <div className="modal-client-head">
                                                <h2 className="">Sprint Status</h2>
                                        </div>
                                        <div className="form-field-client-outer">
                                                <form onSubmit={handleStatusSubmit}>

                                                        <div className="form-field-client">
                                                                <label htmlFor="projectManager" className="form-label">
                                                                        Status
                                                                </label>
                                                                <div className="custom-dropdown">

                                                                        <div ref={sprintStatusDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${sprintStatusDropdownOpen ? 'open' : ''}`}>
                                                                                <div className="selected-option custom-dropdown-user-new" onClick={handleSprintStatusToggleDropdown}>
                                                                                        {sprintStatus ? sprintStatus : sprintData?.sprint_status}
                                                                                </div>
                                                                                {sprintStatusDropdownOpen && (
                                                                                        <div className="custom-dropdown-new">
                                                                                                <ul className="type-list">
                                                                                                        <li className={sprintData?.sprint_status === 'In Progress' ? 'selected-item' : ''} onClick={() => handleSprintStatusSelectOption('In Progress')}>In Progress</li>
                                                                                                        <li className={sprintData?.sprint_status === 'Cancelled' ? 'selected-item' : ''} onClick={() => handleSprintStatusSelectOption('Cancelled')}>Cancelled</li>
                                                                                                        <li className={sprintData?.sprint_status === 'Delivered' ? 'selected-item' : ''} onClick={() => handleSprintStatusSelectOption('Delivered')}>Delivered</li>
                                                                                                </ul>
                                                                                        </div>
                                                                                )}
                                                                        </div>
                                                                        <span className="custom-arrow"></span>
                                                                </div>
                                                        </div>


                                                        {isSubmitLoading ? (
                                                                <SubmitButtonSkeleton />
                                                        ) : (
                                                                <button type="submit" className="submit-client" disabled={isSubmitLoading}>
                                                                        Update
                                                                </button>
                                                        )}
                                                </form>
                                        </div>
                                </div>
                        </Modal>
                        <style>{`
                                @keyframes pulse {
                                        0%, 100% {
                                                opacity: 1;
                                        }
                                        50% {
                                                opacity: 0.5;
                                        }
                                }
                        `}</style>
                </div>
        )
}

export default StatusModal;